import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute"; // Import your new component
import Login from "./pages/Login/Login";
import AdminDashboard from "./pages/Admin/AdminDashboard";
import AdminUserPage from "./pages/Admin/AdminUserPage";
import AdminGroupPage from "./pages/Admin/AdminGroupPage";
import EditGroupAdmin from "./pages/Admin/EditGroupAdmin";
import UserForm from "./pages/Admin/UserForm";
import EditUserAdmin from "./pages/Admin/EditUserAdmin";
import EditUserSelf from "./pages/User/EditUserSelf";
import UserHome from "./pages/User/UserHome";
import WorkHistoryPage from "./pages/User/WorkHistoryPage";
import AppLayout from "./components/AppLayout";
import HealthCard from "./pages/User/HealthCard";
import FastCard from "./pages/User/FastCard";
import Passport from "./pages/User/Passport";
import PRCard from "./pages/User/PRCard";
import USVisa from "./pages/User/USVisa";
import WorkPermitList from "./pages/User/WorkPermitList";
import WorkPermitForm from "./pages/User/WorkPermitForm";
import RoadsideInspectionList from "./pages/User/RoadsideInspectionList";
import RoadsideInspectionForm from "./pages/User/RoadsideInspectionForm";
import DriverLicense from "./pages/User/DriverLicense";
import VacationForm from "./pages/User/VacationForm";
import EmergencyContact from "./pages/User/EmergencyContact";
import CanadaPost from "./pages/User/CanadaPost";
import NearMissPage from "./pages/User/NearMissPage";
import IncidentReports from "./pages/User/IncidentReports";
import IncidentList from "./pages/User/IncidentList";
import IncidentForm from "./pages/User/IncidentForm";
import ViolationList from "./pages/User/ViolationList";
import ViolationForm from "./pages/User/ViolationForm";
import CVSAList from "./pages/User/CVSAList";
import CVSAForm from "./pages/User/CVSAForm";
import EldAudit from "./pages/User/EldAudit";
import ForgotPassword from "./pages/Login/ForgotPassword";
import ResetPassword from "./pages/Login/ResetPassword";
import DangerousWorkPolicy from "./pages/Policies/DangerousWorkPolicy";
import ZeroTolerancePolicy from "./pages/Policies/ZeroTolerancePolicy";
import TruckAssignmentPolicy from "./pages/Policies/TruckAssignmentPolicy";
import DrugAndAlcoholTest from "./pages/Policies/DrugAndAlcoholTest";
import ClearinghouseConsent from "./pages/Policies/ClearinghouseConsent";
import HealthandSafetyManual from "./pages/Policies/HealthandSafetyManual";
import PadlockProbePolicy from "./pages/Policies/PadlockProbePolicy";
import QualificationsPage from "./pages/User/QualificationsPage";
import OfficeEmployeeAgreement from "./pages/Policies/OfficeEmployeeAgreement";
import TaxForm from "./pages/User/TaxForm";
import Resume from "./pages/User/Resume";
import BackgroundCheck from "./pages/Policies/BackgroundCheck";
import BlueCrossDeducation from "./pages/Policies/BlueCrossDeducation";
import ListAllConsentHistory from "./pages/Admin/ListAllConsentHistory";
import ConsentHistoryPage from "./pages/Policies/ConsentHistoryPage";
import SlideWrapper from "./components/SlideWrapper";
import SignedRelease from "./pages/Admin/SignedRelease";
import PspDisclosurePage from "./pages/Policies/PspDisclosurePage";
import RecevingGeneralOrientation from "./pages/Policies/RecevingGeneralOrientation";
import BlueCrossApplication from "./pages/Policies/BlueCrossApplication";
import GatePassPolicy from "./pages/Policies/GatePassPolicy";
import AlbertaAbstractConsent from "./pages/Policies/AlbertaAbstractConsent";
import LEEP from "./pages/Policies/LEEP";
import DirectDeposit from "./pages/User/DirectDeposit";
import JobDescriptionPage from "./pages/Admin/JobDescriptionPage";
import PositionPage from "./pages/Admin/PositionPage";
import ReportListPage from "./pages/Reports/ReportListPage";
import ContactListReport from "./pages/Reports/ContactListReport";
import LeepResponsesReport from "./pages/Reports/LeepResponsesReport";
import TimeAndAttendanceReport from "./pages/Reports/TimeAndAttendanceReport";
import ExpirationsReport from "./pages/Reports/ExpirationsReport";
import HiringCycleReport from "./pages/Reports/HiringCycleReport";
import HiringCycleData from "./pages/Reports/HiringCycleData";
import PositionHistoryReport from "./pages/Reports/PositionHistoryReport";
import TerminationReport from "./pages/Reports/TerminationReport";
import IncidentAccidentRegistry from "./pages/Reports/IncidentAccidentRegistry";
import TagEditorPage from "./pages/Admin/TagEditorPage";
import AccountSettingsPage from "./pages/Admin/AccountSettingsPage";
import TrainingPanel from "./pages/User/TrainingPanel";
import InterviewQuestionsPage from "./pages/User/InterviewQuestionsPage";
import StatusHistoryPage from "./pages/Admin/StatusHistoryPage";
import ApplicationHistoryPage from "./pages/Admin/ApplicationHistoryPage";
import PermissionManager from "./pages/Admin/PermissionManager";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />

        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />

        {/* Protected Routes */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute adminOnly={true}>
              <AppLayout>
                <AdminDashboard />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin-users"
          element={
            <ProtectedRoute
              adminOnly={true}
              page="AdminUser"
              resource="User"
              action="view"
            >
              <AppLayout>
                <AdminUserPage />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin-groups"
          element={
            <ProtectedRoute adminOnly={true}>
              <AppLayout>
                <AdminGroupPage />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin-groups/:groupId"
          element={
            <ProtectedRoute adminOnly={true}>
              <AppLayout>
                <EditGroupAdmin />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/form"
          element={
            <ProtectedRoute adminOnly={true}>
              <AppLayout>
                <UserForm />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/edit-user/:id"
          element={
            <ProtectedRoute adminOnly={true}>
              <AppLayout>
                <EditUserAdmin />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <AppLayout>
                <EditUserSelf />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/userhome"
          element={
            <ProtectedRoute>
              <AppLayout>
                <UserHome />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/userhome/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <UserHome />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/work-history/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <WorkHistoryPage />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/edit-workhistory/:id"
          element={
            <ProtectedRoute adminOnly={true}>
              <AppLayout>
                <WorkHistoryPage />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/healthcard/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <HealthCard />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/edit-healthcard/:id"
          element={
            <ProtectedRoute adminOnly={true}>
              <AppLayout>
                <HealthCard />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/fastcard/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <FastCard />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/edit-fastcard/:id"
          element={
            <ProtectedRoute adminOnly={true}>
              <AppLayout>
                <FastCard />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/passport/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <Passport />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/edit-passport/:id"
          element={
            <ProtectedRoute adminOnly={true}>
              <AppLayout>
                <Passport />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/prcard/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <PRCard />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/edit-prcard/:id"
          element={
            <ProtectedRoute adminOnly={true}>
              <AppLayout>
                <PRCard />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/usvisa/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <USVisa />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/edit-usvisa/:id"
          element={
            <ProtectedRoute adminOnly={true}>
              <AppLayout>
                <USVisa />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        {/* Work Permit Routes */}
        <Route
          path="/workpermit/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <WorkPermitList />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/workpermit/:id/detail/:wpId"
          element={
            <ProtectedRoute>
              <AppLayout>
                <WorkPermitForm />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/edit-workpermit/:id/detail/:wpId"
          element={
            <ProtectedRoute adminOnly={true}>
              <AppLayout>
                <WorkPermitForm />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/workpermit/:id/new"
          element={
            <ProtectedRoute>
              <AppLayout>
                <WorkPermitForm />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/roadside/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <RoadsideInspectionList />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/roadside/:id/detail/:riId"
          element={
            <ProtectedRoute>
              <AppLayout>
                <RoadsideInspectionForm />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/roadside/:id/new"
          element={
            <ProtectedRoute>
              <AppLayout>
                <RoadsideInspectionForm />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/driverlicense/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <DriverLicense />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/edit-driver/:id"
          element={
            <ProtectedRoute adminOnly={true}>
              <AppLayout>
                <DriverLicense />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/vacationform/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <VacationForm />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/edit-vacation/:id"
          element={
            <ProtectedRoute adminOnly={true}>
              <AppLayout>
                <VacationForm />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/emergencycontact/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <EmergencyContact />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/edit-emergency/:id"
          element={
            <ProtectedRoute adminOnly={true}>
              <AppLayout>
                <EmergencyContact />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/canadapost/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <CanadaPost />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/edit-canadapost/:id"
          element={
            <ProtectedRoute adminOnly={true}>
              <AppLayout>
                <CanadaPost />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/nearmisspage/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <NearMissPage />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/incidentreports/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <IncidentReports />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/edit-incident/:id"
          element={
            <ProtectedRoute adminOnly={true}>
              <AppLayout>
                <IncidentReports />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/eld_audit/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <EldAudit />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/edit-eld_audit/:id"
          element={
            <ProtectedRoute adminOnly={true}>
              <AppLayout>
                <EldAudit />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/incidents/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <IncidentList />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/incidents/:id/incident-detail/:incidentId"
          element={
            <ProtectedRoute>
              <AppLayout>
                <IncidentForm />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/incidents/:id/incident-new"
          element={
            <ProtectedRoute>
              <AppLayout>
                <IncidentForm />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/violations/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <ViolationList />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/violations/:id/violation-detail/:violId"
          element={
            <ProtectedRoute>
              <AppLayout>
                <ViolationForm />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/violations/:id/violation-new"
          element={
            <ProtectedRoute>
              <AppLayout>
                <ViolationForm />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/cvsa/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <CVSAList />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/cvsa/:id/detail/:cvsaId"
          element={
            <ProtectedRoute>
              <AppLayout>
                <CVSAForm />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/cvsa/:id/new"
          element={
            <ProtectedRoute>
              <AppLayout>
                <CVSAForm />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/directdeposit/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <DirectDeposit />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/edit-directdeposit/:id"
          element={
            <ProtectedRoute adminOnly={true}>
              <AppLayout>
                <DirectDeposit />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/dangerouswork/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <DangerousWorkPolicy />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/zerotolerance/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <ZeroTolerancePolicy />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/truckassignment/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <TruckAssignmentPolicy />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/drugandalcohol/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <DrugAndAlcoholTest />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/healthandsafety/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <HealthandSafetyManual />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/padlockpolicy/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <PadlockProbePolicy />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/qualifications/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <QualificationsPage />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/agreements/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <OfficeEmployeeAgreement />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/taxform/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <TaxForm />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/gatepasspolicy/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <GatePassPolicy />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/albertaconsent/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <AlbertaAbstractConsent />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/resume/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <Resume />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/backgroundcheck/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <BackgroundCheck />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/bluecrossdeducation/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <BlueCrossDeducation />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/bluecrossapplication/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <BlueCrossApplication />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/leep/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <LEEP />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/recevinggeneralorientation/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <RecevingGeneralOrientation />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/consent/:id/:whId?"
          element={
            <ProtectedRoute>
              <AppLayout>
                <ConsentHistoryPage />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/consent/list/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <ListAllConsentHistory />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/slide/backgroundcheck/:id"
          element={
            <ProtectedRoute>
              <SlideWrapper>
                <BackgroundCheck />
              </SlideWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/slide/psp-disclosure/:id"
          element={
            <ProtectedRoute>
              <SlideWrapper>
                <PspDisclosurePage />
              </SlideWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/slide/consent/:id/:whId"
          element={
            <ProtectedRoute>
              <SlideWrapper>
                <ConsentHistoryPage />
              </SlideWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/signed-release/:id/:whId?"
          element={
            <ProtectedRoute>
              <AppLayout>
                <SignedRelease />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/job-descriptions"
          element={
            <ProtectedRoute adminOnly={true}>
              <AppLayout>
                <JobDescriptionPage />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/positions"
          element={
            <ProtectedRoute adminOnly={true}>
              <AppLayout>
                <PositionPage />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/reports"
          element={
            <ProtectedRoute adminOnly={true}>
              <AppLayout>
                <ReportListPage />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/reports/contact-list"
          element={
            <ProtectedRoute adminOnly={true}>
              <AppLayout>
                <ContactListReport />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/reports/leep-report"
          element={
            <ProtectedRoute adminOnly={true}>
              <AppLayout>
                <LeepResponsesReport />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/reports/time-and-attendance"
          element={
            <ProtectedRoute adminOnly={true}>
              <AppLayout>
                <TimeAndAttendanceReport />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/reports/expirations"
          element={
            <ProtectedRoute adminOnly={true}>
              <AppLayout>
                <ExpirationsReport />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/reports/hiring-cycle"
          element={
            <ProtectedRoute adminOnly={true}>
              <AppLayout>
                <HiringCycleReport />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/reports/hiring-cycle-data"
          element={
            <ProtectedRoute adminOnly={true}>
              <AppLayout>
                <HiringCycleData />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/reports/position-history"
          element={
            <ProtectedRoute adminOnly={true}>
              <AppLayout>
                <PositionHistoryReport />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/reports/termination"
          element={
            <ProtectedRoute adminOnly={true}>
              <AppLayout>
                <TerminationReport />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/reports/incident-accident-registry"
          element={
            <ProtectedRoute adminOnly={true}>
              <AppLayout>
                <IncidentAccidentRegistry />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/tags/:userId"
          element={
            <ProtectedRoute adminOnly={true}>
              <AppLayout>
                <TagEditorPage />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/account-setting"
          element={
            <ProtectedRoute
              adminOnly={true}
              page="AccountSetting"
              resource="Account Setting"
              action="view"
            >
              <AppLayout>
                <AccountSettingsPage />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/training/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <TrainingPanel />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/interview/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <InterviewQuestionsPage />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/clearinghouse/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <ClearinghouseConsent />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/status-history/:id"
          element={
            <ProtectedRoute adminOnly={true}>
              <AppLayout>
                <StatusHistoryPage />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/application-history/:id"
          element={
            <ProtectedRoute adminOnly={true}>
              <AppLayout>
                <ApplicationHistoryPage />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/permissions"
          element={
            <ProtectedRoute
              adminOnly={true}
              page="PermissionManagerPage"
              resource="Permissions"
              action="view"
            >
              <AppLayout>
                <PermissionManager />
              </AppLayout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
